import React from 'react';
import { useIntl } from 'react-intl';

import { useContentRestriction } from 'hooks';

import CardTitleBubbleView from './components/CardTitleBubbleView/CardTitleBubbleView';
import CardTitleStaticView from './components/CardTitleStaticView/CardTitleStaticView';

const CardTitle = ({
  isStaticInfo,
  title,
  isWrapperWithIcon,
  seasonEpisodeTitle,
  isMosaicProgram,
  isAdult,
  isRecord,
  isSeriesRecord,
}: {
  isStaticInfo?: boolean;
  title: string;
  isWrapperWithIcon?: boolean;
  seasonEpisodeTitle?: string;
  isMosaicProgram: boolean;
  isAdult?: boolean;
  isRecord: boolean;
  isSeriesRecord: boolean;
}) => {
  // for avoiding wrapping the whole parent component with observer
  const isContentRestricted = useContentRestriction(Boolean(isAdult));
  // translation and title
  const intl = useIntl();
  const restrictedTitle = intl.formatMessage({
    id: 'Rail.RailCard.restrictedContent',
    defaultMessage: 'Restricted content',
  });
  const cardTitle = isContentRestricted ? restrictedTitle : title;

  return (
    <>
      {isStaticInfo ? (
        <CardTitleStaticView
          title={cardTitle}
          seasonEpisodeTitle={seasonEpisodeTitle}
          isRecord={isRecord}
          isWrapperWithIcon={isWrapperWithIcon}
          isWithSeriesRecord={isSeriesRecord}
          isSeriesType={isSeriesRecord}
          isMosaicProgram={isMosaicProgram}
        />
      ) : (
        <CardTitleBubbleView
          title={cardTitle}
          isRecord={isRecord}
          isWrapperWithIcon={isWrapperWithIcon}
          isWithSeriesRecord={isSeriesRecord}
          isSeriesType={isSeriesRecord}
          isMosaicProgram={isMosaicProgram}
        />
      )}
    </>
  );
};

export default CardTitle;
